<template>
  <div
    class="rounded-full px-2 py-1 inline-flex items-center justify-center"
    :class="currentBgClass"
  >
    <span :class="[textClass, currentTextColorClass]">
      <slot />
      <template v-if="text && !$slots.default">
        {{ text }}
      </template>
    </span>
  </div>
</template>

<script>
const styleVariantsMap = {
  default: {
    bgClass: 'bg-primary-main',
    textColorClass: 'text-white',
  },
  light: {
    bgClass: 'bg-gray-100',
    textColorClass: 'text-primary',
  }
}

export default {
  props: {
    text: {
      type: String,
    },
    bgClass: {
      type: [String, Object, Array],
      default: 'bg-primary-main',
    },
    textColorClass: {
      type: [String, Object, Array],
      default: 'text-white',
    },
    textClass: {
      type: [String, Object, Array],
      default: 'text-xs font-semibold',
    },
    variant: {
      type: String,
      default: 'default',
      validator(value) {
        return Object.keys(styleVariantsMap).includes(value);
      }
    }
  },
  computed: {
    currentStyle() {
      return styleVariantsMap[this.variant] || styleVariantsMap.default;
    },
    currentBgClass() {
      return this.currentStyle.bgClass;
    },
    currentTextColorClass() {
      return this.currentStyle.textColorClass;
    },
  }
}
</script>

<style lang="scss" scoped></style>